import type { TenantAccount } from "~/api/Api";
import { Authorizations } from "~/api/types";
import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";
import { useTenantAccount } from "~/hooks/useTenantAccount";

import Settings from "../../components/settings/Settings";
import Breadcrumbs from "../../components/ui/breadcrumbs/Breadcrumbs";
import styles from "./Settings.module.scss";

export type TenantData = {
  account: TenantAccount | null;
  authorizations: Authorizations | undefined;
};

const DEFAULT_TENANT_DATA: TenantData = {
  account: null,
  authorizations: undefined,
};

const SettingsPage = () => {
  usePageTitle(PAGE_TITLES.settings);
  const { data: tenantAccountData = DEFAULT_TENANT_DATA } =
    useTenantAccount("withAuth");

  const fakeBreadcrumbs = [
    {
      title: PAGE_TITLES.dashboard,
      link: "/",
    },
    {
      title: PAGE_TITLES.settings,
      link: `/settings/account`,
    },
  ];

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{PAGE_TITLES.settings}</h1>
      <>
        {fakeBreadcrumbs?.length && (
          <Breadcrumbs fakeBreadcrumbs={fakeBreadcrumbs} />
        )}
      </>
      <Settings tenantAccountData={tenantAccountData} />
    </div>
  );
};
export default SettingsPage;
